import { render } from "./VtoPageHairDetection.vue?vue&type=template&id=20fcbaf9"
import script from "./VtoPageHairDetection.vue?vue&type=script&lang=js"
export * from "./VtoPageHairDetection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__